import type { LocalePhrasesRoot } from '../types';

const cs: LocalePhrasesRoot = {
  auth: {
    login: 'Přihlásit',
    loggingIn: 'Přihlašování…',
    loginWithNetlifyIdentity: 'Přihlásit pomocí Netlify Identity',
    loginWithBitbucket: 'Přihlásit pomocí Bitbucket',
    loginWithGitHub: 'Přihlásit pomocí GitHub',
    loginWithGitLab: 'Přihlásit pomocí GitLab',
    loginWithGitea: 'Přihlásit pomocí Gitea',
    errors: {
      email: 'Vyplňte e-mailovou adresu.',
      password: 'Vyplňte heslo.',
      authTitle: 'Chyba během přihlašování',
      authBody: '%{details}',
      netlifyIdentityNotFound: 'Netlify Identity plugin nebyl nalezen',
      identitySettings:
        'Nastavení identity nenalezeno. Používáte-li git-gateway server nezapomeňte aktivovat službu Identity a Git Gateway.',
    },
  },
  app: {
    header: {
      content: 'Obsah',
      workflow: 'Workflow',
      media: 'Média',
      quickAdd: 'Přidat',
    },
    app: {
      loading: 'Načítání…',
      errorHeader: 'Chyba při načítání CMS konfigurace',
      configErrors: 'Chyba konfigurace',
      configNotFound: 'Konfigurace nebyla nalezena',
      checkConfigYml: 'Zkontrolujte soubor config.yml.',
      loadingConfig: 'Načítání konfigurace…',
      waitingBackend: 'Čekání na server…',
    },
    notFoundPage: {
      header: 'Nenalezeno',
    },
  },
  collection: {
    sidebar: {
      collections: 'Kolekce',
      allCollections: 'Všechny kolekce',
      searchAll: 'Hledat',
      searchIn: 'Hledat v',
    },
    collectionTop: {
      sortBy: 'Seřadit podle',
      viewAs: 'Zobrazit jako',
      newButton: 'Nový %{collectionLabel}',
      ascending: 'Vzestupné',
      descending: 'Sestupné',
      searchResults: 'Výsledky vyhledávání pro "%{searchTerm}"',
      searchResultsInCollection: 'Výsledky vyhledávání pro "%{searchTerm}" v kolekci %{collection}',
      filterBy: 'Filtrovat podle',
      groupBy: 'Seskupit podle',
    },
    entries: {
      loadingEntries: 'Načítání záznamů',
      cachingEntries: 'Úkládání záznamů do mezipaměti',
      longerLoading: 'Načítání může trvat několik minut',
      noEntries: 'Žádné záznamy',
    },
    groups: {
      other: 'Ostatní',
      negateLabel: 'Není %{label}',
    },
    table: {
      summary: 'Přehled',
      collection: 'Kolekce',
    },
    defaultFields: {
      author: {
        label: 'Autor',
      },
      updatedOn: {
        label: 'Poslední aktualizace',
      },
    },
    notFound: 'Kolekce nebyla nalezena',
  },
  editor: {
    editorControl: {
      field: {
        optional: 'volitelný',
      },
    },
    editorControlPane: {
      widget: {
        required: '%{fieldLabel} je povinný.',
        regexPattern: '%{fieldLabel} nesouhlasí s předepsaným vzorem: %{pattern}.',
        processing: '%{fieldLabel} se zpracovává.',
        range: '%{fieldLabel} musí být mezi %{minValue} a %{maxValue}.',
        min: '%{fieldLabel} musí být alespoň %{minValue}.',
        max: '%{fieldLabel} musí být %{maxValue} nebo méně.',
        rangeCount: '%{fieldLabel} musí mít %{minCount} až %{maxCount} položek.',
        rangeCountExact: '%{fieldLabel} musí mít přesně %{count} položek.',
        rangeMin: '%{fieldLabel} musí mít nejméně %{minCount} položky.',
        rangeMax: '%{fieldLabel} musí mít %{maxCount} nebo méně položek.',
        invalidPath: "'%{path}' není platnou cestou.",
        pathExists: "Cesta '%{path}' už existuje.",
        invalidColor: "Barva '%{color}' není platná.",
        invalidHexCode: 'Hexadecimální barvy musí začínat znakem #',
      },
      i18n: {
        writingInLocale: 'Psát v %{locale}',
        copyFromLocale: 'Vyplnit z jiné lokalizace',
        copyFromLocaleConfirm:
          'Chcete vyplnit data z lokalizace %{locale}?\nVšechen existující obsah bude přepsán.',
      },
    },
    editor: {
      onLeavePage: 'Chcete opravdu opustit tuto stránku?',
      onUpdatingWithUnsavedChangesTitle: 'Neuložené změny',
      onUpdatingWithUnsavedChangesBody:
        'Máte neuložené změny. Uložte je prosím před změnou statusu.',
      onPublishingNotReadyTitle: 'Není připraven k publikování',
      onPublishingNotReadyBody: 'Změňte stav na „Připraveno“ před publikováním.',
      onPublishingWithUnsavedChangesTitle: 'Neuložené změny',
      onPublishingWithUnsavedChangesBody:
        'Máte neuložené změny, prosím uložte je před publikováním.',
      onPublishingTitle: 'Publikovat záznam?',
      onPublishingBody: 'Chcete opravdu publikovat tento záznam?',
      onUnpublishingTitle: 'Zrušit publikování záznamu?',
      onUnpublishingBody: 'Chcete opravdu zrušit publikování tohoto záznamu?',
      onDeleteWithUnsavedChangesTitle: 'Smazat publikovaný záznam?',
      onDeleteWithUnsavedChangesBody:
        'Chcete opravdu vymazat tento publikovaný záznam a všechny neuložené změny z této relace?',
      onDeletePublishedEntryTitle: 'Smazat publikovaný záznam?',
      onDeletePublishedEntryBody: 'Chcete opravdu smazat tento publikovaný záznam?',
      onDeleteUnpublishedChangesWithUnsavedChangesTitle: 'Smazat nepublikované změny?',
      onDeleteUnpublishedChangesWithUnsavedChangesBody:
        'Tato akce vymaže všechny nepublikované změny v tomto záznamu a také všechny neuložené změny z této relace. Chcete záznam skutečně vymazat?',
      onDeleteUnpublishedChangesTitle: 'Smazat nepublikované změny?',
      onDeleteUnpublishedChangesBody:
        'Všechny nepublikované změny v tomto záznamu budou vymazány. Chcete ho skuteně vymazat?',
      loadingEntry: 'Načítání záznamu…',
    },
    editorInterface: {
      sideBySideI18n: 'Lokalizace vedle sebe',
      preview: 'Náhled',
      toggleI18n: 'Přepnout lokalizaci',
      togglePreview: 'Přepnout náhled',
      toggleScrollSync: 'Sladit skrolování',
    },
    editorToolbar: {
      publishing: 'Publikování…',
      publish: 'Publikovat',
      published: 'Publikovaný',
      unpublish: 'Zrušit publikování',
      duplicate: 'Duplikovat',
      unpublishing: 'Rušení publikování…',
      publishAndCreateNew: 'Publikovat a vytvořit nový',
      publishAndDuplicate: 'Publikovat a duplikovat',
      deleteUnpublishedChanges: 'Vymazat nepublikované změny',
      deleteUnpublishedEntry: 'Vymazat nepublikovaný záznam',
      deletePublishedEntry: 'Vymazat publikovaný záznam',
      deleteEntry: 'Vymazat záznam',
      saving: 'Ukládání…',
      save: 'Uložit',
      statusInfoTooltipDraft:
        "Status záznamu je nastavený na draft. Pro odeslání záznamu k revizi změňte status záznamu na 'Revize'",
      statusInfoTooltipInReview:
        'Záznam je v revizi, žádné další změny od vás nejsou vyžadovány, ale i přesto můžete záznam upravovat.',
      deleting: 'Vymazávání…',
      updating: 'Aktualizace…',
      status: 'Status: %{status}',
      backCollection: ' Píšete v kolekci %{collectionLabel}',
      unsavedChanges: 'Neuložené změny',
      changesSaved: 'Změny uloženy',
      draft: 'Koncept',
      inReview: 'V revizi',
      ready: 'Připraveno',
      publishNow: 'Publikovat teď',
      deployPreviewPendingButtonLabel: 'Zkontrolovat náhled',
      deployPreviewButtonLabel: 'Zobrazit náhled',
      deployButtonLabel: 'Zobrazit na webu',
      discardChanges: 'Zrušit změny',
      discardChangesTitle: 'Zrušit změny',
      discardChangesBody: 'Opravdu chcete zrušit všechny neuložené změny?',
    },
    editorWidgets: {
      markdown: {
        bold: 'Tučně',
        italic: 'Kurzíva',
        strikethrough: 'Přeškrtnuté',
        code: 'Kód',
        codeBlock: 'Blok kódu',
        insertCodeBlock: 'Vložit blok kódu',
        link: 'Odkaz',
        insertLink: 'Vložit odkaz',
        paragraph: 'Odstavec',
        headings: 'Nadpisy',
        quote: 'Citovat',
        insertQuote: 'Vložit citaci',
        bulletedList: 'Odrážkový seznam',
        numberedList: 'Číslovaný seznam',
        addComponent: 'Přidat součástku',
        richText: 'Rich Text',
        markdown: 'Markdown',
        type: 'Pište...',
        decreaseIndent: 'Snížit odsazení',
        increaseIndent: 'Zvýšit odsazení',
        image: 'Obrázek',
        insertImage: 'Vložit obrázek',
        table: {
          table: 'Tabulka',
          deleteColumn: 'Smazat sloupec',
          deleteRow: 'Smazat řádek',
          deleteTable: 'Smazat tabulku',
          insertColumn: 'Vložit sloupec',
          insertRow: 'Vložit řádek',
          insertTable: 'Vložit tabulku',
        },
      },
      image: {
        choose: 'Vyberte obrázek',
        chooseMultiple: 'Vyberte obrázky',
        chooseUrl: 'Přidat z URL',
        replaceUrl: 'Nahradit z URL',
        promptUrl: 'Zadejte URL obrázku',
        chooseDifferent: 'Vyberte jiný obrázek',
        addMore: 'Přidat další obrázky',
        remove: 'Odebrat obrázek',
        removeAll: 'Odebrat všechny obrázky',
      },
      file: {
        choose: 'Vyberte soubor',
        chooseUrl: 'Přidat z URL',
        chooseMultiple: 'Vyberte soubory',
        replaceUrl: 'Nahradit z URL',
        promptUrl: 'Zadejte URL souboru',
        chooseDifferent: 'Vyberte jiný soubor',
        addMore: 'Přidat další soubory',
        remove: 'Odebrat soubor',
        removeAll: 'Odebrat všechny soubory',
      },
      folder: {
        choose: 'Vybrat složku',
        chooseUrl: 'Vložit cestu na složku',
        chooseMultiple: 'Vybrat složky',
        replaceUrl: 'Nahradit cestou',
        promptUrl: 'Vložte cestu na složku',
        chooseDifferent: 'Vyberte jinou složku',
        addMore: 'Přidat více složek',
        remove: 'Odstranit složku',
        removeAll: 'Odstranit všechny složky',
      },
      unknownControl: {
        noControl: "Žádné ovládání pro widget '%{widget}'.",
      },
      unknownPreview: {
        noPreview: "Žádný náhled pro widget '%{widget}'.",
      },
      headingOptions: {
        headingOne: 'Nadpis 1',
        headingTwo: 'Nadpis 2',
        headingThree: 'Nadpis 3',
        headingFour: 'Nadpis 4',
        headingFive: 'Nadpis 5',
        headingSix: 'Nadpis 6',
      },
      datetime: {
        now: 'Teď',
        invalidDateTitle: 'Neplatné datum',
        invalidDateBody: 'Datum není validní.',
      },
      list: {
        add: 'Vložit %{item}',
        addType: 'Vložit %{item}',
        noValue: 'Žádná hodnota',
      },
      keyvalue: {
        key: 'Klíč',
        value: 'Hodnota',
        uniqueKeys: '%{keyLabel} musí být unikátní',
      },
      code: {
        language: 'Jazyk',
        selectLanguage: 'Vyberte jazyk',
      },
    },
  },
  mediaLibrary: {
    mediaLibraryCard: {
      draft: 'Koncept',
      copy: 'Kopírovat',
      copyUrl: 'Kopírovat URL',
      copyPath: 'Kopírovat cestu',
      copyName: 'Kopírovat název',
      copied: 'Zkopírováno',
    },
    mediaLibrary: {
      onDeleteTitle: 'Vymazat',
      onDeleteBody: 'Chcete skutečně vymazat označená média?',
      fileTooLargeTitle: 'Soubor je příliš velký',
      fileTooLargeBody: 'Soubor je příliš velký.\nSoubor musí být menší než %{size} kB.',
      alreadyExistsTitle: 'Soubor již existuje',
      alreadyExistsBody: '%{filename} již existuje. Chcete ho nahradit?',
    },
    mediaLibraryModal: {
      noResults: 'Nic nenalezeno.',
      noAssetsFound: 'Média nenalezena.',
      noImagesFound: 'Obrázky nenalezeny.',
      private: 'Soukromé ',
      images: 'Obrázky',
      mediaAssets: 'Média',
      search: 'Hledat…',
      uploading: 'Nahrávání…',
      upload: 'Nahrát nový',
      download: 'Stáhnout',
      deleting: 'Vymazávání…',
      deleteSelected: 'Smazat označené',
      chooseSelected: 'Vybrat označené',
      dropImages: 'Odebrat obrázky pro nahrání',
      dropFiles: 'Odebrat soubory pro nahrání',
    },
    folderSupport: {
      newFolder: 'Nová složka',
      createNewFolder: 'Vytvořit novou složku',
      enterFolderName: 'Vložte název nové složky...',
      create: 'Vytvořit',
      home: 'Domů',
      up: 'Nahoru',
      upToFolder: 'Nahoru na %{folder}',
    },
  },
  ui: {
    common: {
      yes: 'Ano',
      no: 'Ne',
      okay: 'OK',
      cancel: 'Zrušit',
    },
    default: {
      goBackToSite: 'Vrátit se na stránku',
    },
    localBackup: {
      hasLocalBackup: 'Záloha obsahuje je lokálně',
    },
    errorBoundary: {
      title: 'Chyba',
      details: 'Nastala chyba – prosím ',
      reportIt: 'nahlašte ji.',
      detailsHeading: 'Detaily',
      privacyWarning:
        'Při otevření problému budou předvyplněny ladící data a chybová zpráva.\nProsím zkontrolujte, jestli jsou informace správné, a případně odstraňte citlivé údaje.',
      recoveredEntry: {
        heading: 'Nalezený dokument',
        warning: 'Prosím zkopírujte dokument do schránky před tím než odejte z této stránky!',
        copyButtonLabel: 'Zkopírovat do schránky',
      },
    },
    settingsDropdown: {
      theme: 'Motiv',
      logOut: 'Odhlásit',
    },
    toast: {
      onFailToLoadEntries: 'Chyba při načítání záznamu: %{details}',
      onFailToLoadDeployPreview: 'Chyba při načítání náhledu: %{details}',
      onFailToPersist: 'Chyba při ukládání záznamu: %{details}',
      onFailToPersistMedia: 'Chyba při ukládání média: %{details}',
      onFailToDelete: 'Chyba při vymazávání záznamu: %{details}',
      onFailToDeleteMedia: 'Chyba při vymazávání média: %{details}',
      onFailToUpdateStatus: 'Chyba při změně stavu záznamu: %{details}',
      missingRequiredField: 'Vynechali jste povinné pole. Prosím vyplňte ho.',
      entrySaved: 'Záznam uložen',
      entryDeleted: 'Záznam smazán',
      entryPublished: 'Záznam publikován',
      entryUnpublished: 'Publikování záznamu zrušeno',
      onFailToPublishEntry: 'Chyba při publikování záznamu: %{details}',
      onFailToUnpublishEntry: 'Chyba při rušení publikování záznamu: %{details}',
      entryUpdated: 'Stav záznamu byl změněn',
      onDeletePublishedEntry: 'Publikovaný záznam byl smazán',
      onDeleteUnpublishedChanges: 'Nepublikované změny byly smazány',
      onFailToAuth: '%{details}',
      onLoggedOut: 'Byli jste odhlášeni, prosím zálohujte všechna data a znova se přihlašte',
      onBackendDown: 'Backend zaznamenal výpadek. Podívejte se do %{details} pro více informací.',
    },
  },
  workflow: {
    workflow: {
      dashboard: 'Nástěnka',
      loading: 'Načítání workflow záznamů',
      workflowHeading: 'Schvalovací Workflow',
      newPost: 'Nový post',
      description:
        '%{smart_count} záznam čeká na schválení, %{readyCount} připraven k publikaci. |||| %{smart_count} čeká na schválení, %{readyCount} připraveno k publikaci. ',
      dateFormat: 'MMMM D',
    },
    workflowCard: {
      lastChange: '%{date} (%{author})',
      lastChangeNoAuthor: '%{date}',
      lastChangeNoDate: '%{author}',
      deleteChanges: 'Vymazat změny',
      deleteNewEntry: 'Vymazat nový záznam',
      publishChanges: 'Publikovat změny',
      publishNewEntry: 'Publikovat nový záznam',
    },
    workflowList: {
      onDeleteEntry: 'Opravdu chcete smazat tento záznam?',
      onPublishingNotReadyEntry:
        'Pouze položky se statusem "Připraveno" mohou být publikováno. Pro umožnění publikace musíte přetáhnout kartu do sloupce "Připraveno"',
      onPublishEntry: 'Opravdu chcete publikovat tento záznam?',
      draft: 'Koncepty',
      pending_review: 'V revizi',
      pending_publish: 'Připraveno',
      currentEntries: '%{smart_count} záznam |||| %{smart_count} záznamů',
    },
    openAuthoring: {
      forkRequired:
        'Veřejné psaní od jiných uživatelů je povoleno. Potřebujeme zkopírovat váš github účet, pokud kopie ještě nebyla pořízena.',
      forkRepo: 'Vytvořit kopii repozitáře',
      markReadyForReview: 'Odeslat záznam k revizi',
    },
  },
};

export default cs;
